import React from 'react';

function Projects() {
  return (
    <section
      id="projects"
      className="bg-slate-900 text-white px-6 py-20 scroll-mt-28"
    >
      <h2 className="text-4xl font-extrabold mb-12 text-center">Projects</h2>

      <div className="space-y-14 max-w-5xl mx-auto">

        {/* Project 1 - WareIQ */}
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold leading-snug">
            WareIQ powers eCommerce logistics — Multi-Cloud CI/CD & Observability Platform
          </h3>
          <p className="text-gray-400 italic">Jul 2025 – Present</p>
          <ul className="list-disc pl-5 mt-2 space-y-2 text-base">
            <li>Designed and managed Jenkins pipelines to deploy 40+ microservices across AWS and GCP.</li>
            <li>Provisioned cloud infrastructure using Terraform and IAM roles for GKE clusters.</li>
            <li>Integrated Trivy and Snyk for container image scanning and DevSecOps policy enforcement.</li>
            <li>Configured Prometheus, Grafana, and Loki for real-time monitoring, logging, and alerting.</li>
            <li>Automated multi-tenant deployments with Jenkins pipelines and GitOps-style workflows.</li>
            <li>Achieved cross-region high availability and reduced deployment downtime by 95%.</li>
          </ul>
        </div>

        {/* Project 2 - WhatsApp Business */}
        {/* 
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold leading-snug">
            WhatsApp Business Suite — Cloud-Native Automation with AWS EKS
          </h3>
          <p className="text-gray-400 italic">Jun 2023 – Jul 2025</p>
          <ul className="list-disc pl-5 mt-2 space-y-2 text-base">
            <li>Designed AWS EKS cluster and automated provisioning using Terraform.</li>
            <li>Developed GitLab and Jenkins CI/CD pipelines for automated build, scan, and deploy.</li>
            <li>Integrated SonarQube, Snyk, and Trivy into pipelines for DevSecOps compliance.</li>
            <li>Deployed services via Helm charts to EKS with environment-specific overrides.</li>
            <li>Enabled monitoring and log aggregation with Prometheus, Grafana, and Loki.</li>
            <li>Ensured infrastructure scalability to support 1,000+ concurrent users.</li>
          </ul>
        </div>
        */}

        {/* Project 3 - Bizmagnets AI */}
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold leading-snug">
            WhatsApp Business Suite - Bizmagnets AI
          </h3>
          <p className="text-gray-400 italic">Jun 2023 – Jul 2025</p>
          <ul className="list-disc pl-5 mt-2 space-y-2 text-base">
            <li>Provisioned full AWS infrastructure using Terraform, including EKS, RDS, S3, EC2, and IAM.</li>
            <li>Hosted Java backend application using WebSockets in EKS with autoscaled scheduler services.</li>
            <li>Resolved WebSocket session stickiness with NGINX ingress controller and session affinity.</li>
            <li>Hosted React frontend in S3 with CloudFront and ACM-secured HTTPS setup.</li>
            <li>Deployed Redis on EC2 for session handling and job queue management.</li>
            <li>Used GitLab CI and Jenkins for container build and EKS deployment automation.</li>
            <li>Monitored real-time system metrics using Prometheus, Grafana, and alerting rules.</li>
            <li>Ensured infrastructure scalability for 1,000+ concurrent users.</li>
          </ul>
        </div>

        {/* Project 4 - GPSVTS */}
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold leading-snug">
            GPSVTS — Scalable DevOps Infrastructure for GPS Tracking
          </h3>
          <p className="text-gray-400 italic">Jun 2023 – Jul 2025</p>
          <ul className="list-disc pl-5 mt-2 space-y-2 text-base">
            <li>Designed and deployed secure AWS infrastructure for 30,000+ GPS tracking devices.</li>
            <li>Created optimized Jenkins CI/CD pipelines reducing build time by over 50%.</li>
            <li>Configured Redis with master-slave replication for performance tuning.</li>
            <li>Implemented Prometheus and Grafana for real-time system monitoring.</li>
            <li>Automated backup and disaster recovery for MySQL and Redis databases.</li>
            <li>Used NGINX as reverse proxy for secure traffic routing and load balancing.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Projects;
